import { createApiClient, createApiTestkit } from '@wix/premium-fed-sdk/@apis-infra-react';
import { createQueriesConfig } from '@wix/premium-fed-sdk/apis-infra';
const API = '/_api/premium-package-pickers-api';
const getPersonalizedFeaturesQueryFn = async _ref => {
  let {
    httpClient,
    request
  } = _ref;
  const response = await httpClient.post(`${API}/get-personalized-features`, request);
  return response.data;
};
export const PersonalizedFeaturesQueriesConfig = createQueriesConfig({
  getPersonalizedFeatures: {
    queryFn: getPersonalizedFeaturesQueryFn
  }
});
export const PersonalizedFeaturesApiClient = createApiClient(PersonalizedFeaturesQueriesConfig);
export const PersonalizedFeaturesApiClientTestkit = createApiTestkit(PersonalizedFeaturesQueriesConfig);
//# sourceMappingURL=personalized-features.api-client.js.map